import * as yup from "yup";
import { MIN_PAYOUT_AMOUNT } from "../../utills/constants";

export const CreatePayoutValidation = yup.object().shape({
  mode: yup
    .string()
    .required("Please choose account type.")
    .oneOf(["bank_account", "vpa"]),
  amount: yup
    .number()
    .required("Please enter amount")
    .min(
      MIN_PAYOUT_AMOUNT,
      `Amount should be greater than ${MIN_PAYOUT_AMOUNT}`
    )
    .max(
      yup.ref("availableBalance"),
      "Amount should not be greater than available balance"
    ),
});
